module.exports = "//cdn.mxpnl.com/static/asset-cache/15d6260cef0cbd8c488b37440781603a/iron/common/widgets/warning-hero/images/empty-insights.svg";